import css from 'styled-jsx/css';

const styles = css.global`.jornada-simulacao .informative {
  min-height: min(633px, 50vh);
}

.jornada-simulacao .informative-img {
  max-width: 98px;
  margin: 0 auto 16px;
  padding: 0;
  object-fit: contain;
  width: 100%;
  height: auto;
  display: flex;
}

.jornada-simulacao .informative-title {
  font-family: 'SantanderMicroText';
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  color: #222;
  margin: 0 0 8px;
  display: block;
}

.jornada-simulacao .informative-subtitle {
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: center;
  color: #727272;
  margin: 0;
}

@media (min-width: 992px) {
  .jornada-simulacao .informative {
    margin-top: 128px;
  }
}
`;

export default styles;